import { ButtonERP } from "@finanedi.es/storybook"
import {
  faArrowLeft,
  faArrowsRotateReverse,
  faFileExport,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { TFunction } from "i18next"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
// import { getPeriodoAnual0A } from "./constants"
import { useDeclaracion390 } from "api/DeclaracionModelo.hook"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import Spinner from "common/components/Spinner"
import notification from "common/utils/notification"
import * as Yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import IdentificacionModelo390 from "./01IdentificacionModelo390"
import DevengoModelo390 from "./02DevengoModelo390"
import { DatosEstadisticos } from "./03DatosEstadisticos"
import { DatosRepresentante } from "./04DatosRepresentante"
import OperacionesRegimenGeneral from "./05OperacionesRegimenGeneral/05OperacionesRegimenGeneral"
import { ResultadoLiquidacionAnual } from "./07ResultadoLiquidacionAnual"
import TributacionPorTerritorio from "./08TributacionPorTerritorio"
import ResultadoLiquidaciones from "./09ResultadoLiquidaciones"
import VolumenDeOperaciones from "./10VolumenDeOperaciones"
import OperacionesEspecificas from "./11OperacionesEspecificas"
import Prorrata from "./12Prorrata/12Prorrata"
import ActividadesRegimenesDeduccionDiferenciados from "./13ActividadesRegimenesDeduccionDiferenciados/13ActividadesRegimenesDeduccionDiferenciados"
import ModalPresentarModelo390 from "./ModalPresentarModelo390"

const SECCIONES_TYPES = {
  SUJETO_PASIVO: 1,
  DEVENGO: 2,
  DATOS_ESTADISTICOS: 3,
  DATOS_REPRESENTANTE: 4,
  OPERACIONES_REGIMEN_GENERAL: 5,
  RESULTADO_LIQUIDACION_ANUAL: 7,
  TRIBUTACION_POR_TERRITORIO: 8,
  RESULTADO_LIQUIDACIONES: 9,
  VOLUMEN_OPERACIONES: 10,
  OPERACIONES_ESPECIFICAS: 11,
  PRORRATA: 12,
  REGIMENES_DEDUCCION_DIFERENCIADOS: 13,
}

const schemaModelo390 = Yup.object({
  actividadPrincipalDescripcion: Yup.string().required(),
  actividadPrincipalCodigo: Yup.string().required(),
  actividadPrincipalEpigrafe: Yup.string().required(),
}).required()
export type Modelo390Form = Yup.InferType<typeof schemaModelo390>

const SECCIONES = (t: TFunction) => [
  {
    id: SECCIONES_TYPES.SUJETO_PASIVO,
    label: `1 - ${t("modelo390.sections.subject")}`,
  },
  {
    id: SECCIONES_TYPES.DEVENGO,
    label: `2 - ${t("modelo390.sections.accrual")}`,
  },
  {
    id: SECCIONES_TYPES.DATOS_ESTADISTICOS,
    label: `3 - ${t("modelo390.sections.statisticalData")}`,
  },
  {
    id: SECCIONES_TYPES.DATOS_REPRESENTANTE,
    label: `4 - ${t("modelo390.sections.representativeData")}`,
  },
  {
    id: SECCIONES_TYPES.OPERACIONES_REGIMEN_GENERAL,
    label: `5 - ${t("modelo390.sections.generalRegimeOperations")}`,
  },
  {
    id: SECCIONES_TYPES.RESULTADO_LIQUIDACION_ANUAL,
    label: `7 - ${t("modelo390.sections.annualSettlementResult")}`,
  },
  {
    id: SECCIONES_TYPES.TRIBUTACION_POR_TERRITORIO,
    label: `8 - ${t("modelo390.sections.territorialTaxation")}`,
  },
  {
    id: SECCIONES_TYPES.RESULTADO_LIQUIDACIONES,
    label: `9 - ${t("modelo390.sections.settlementResult")}`,
  },
  {
    id: SECCIONES_TYPES.VOLUMEN_OPERACIONES,
    label: `10 - ${t("modelo390.sections.operationsVolume")}`,
  },
  {
    id: SECCIONES_TYPES.OPERACIONES_ESPECIFICAS,
    label: `11 - ${t("modelo390.sections.specificOperations")}`,
  },
  {
    id: SECCIONES_TYPES.PRORRATA,
    label: `12 - ${t("modelo390.sections.prorata")}`,
  },
  {
    id: SECCIONES_TYPES.REGIMENES_DEDUCCION_DIFERENCIADOS,
    label: `13 - ${t("modelo390.sections.differentiatedDeductionRegimes")}`,
  },
]

const DeclaracionModelo390 = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [tabSelected, setSelectedTab] = useState(SECCIONES_TYPES.SUJETO_PASIVO)
  const [isUpdating, setIsUpdating] = useState<boolean>(false)
  const [prorrataActivityCount, setProrrataActivityCount] = useState(1)
  const [showModalPresentar, setShowModalPresentar] = useState<boolean>(false)
  const {
    activeCompany: { razonSocial, nif },
  } = useUsuarioEmpresaActiva()
  const { state } = useLocation() as { state?: { year?: number } }

  const {
    declaracion390Data,
    declaracion390DataIsLoading,
    declaracion390DataRefetch,
  } = useDeclaracion390({
    queryParams: {
      Anyo: Number(state?.year),
    },
    razonSocial,
    nif,
    year: state?.year,
  })

  const defaultValues = {
    casilla01: declaracion390Data?.casilla01,
    casilla02: declaracion390Data?.casilla02,
    casilla03: declaracion390Data?.casilla03,
    casilla04: declaracion390Data?.casilla04,
    casilla05: declaracion390Data?.casilla05,
    casilla06: declaracion390Data?.casilla06,
    casilla103: declaracion390Data?.casilla103,
    casilla125: declaracion390Data?.casilla125,
    casilla190: declaracion390Data?.casilla190,
    casilla191: declaracion390Data?.casilla191,
    casilla21: declaracion390Data?.casilla21,
    casilla22: declaracion390Data?.casilla22,
    casilla220: declaracion390Data?.casilla220,
    casilla221: declaracion390Data?.casilla221,
    casilla23: declaracion390Data?.casilla23,
    casilla24: declaracion390Data?.casilla24,
    casilla25: declaracion390Data?.casilla25,
    casilla26: declaracion390Data?.casilla26,
    casilla27: declaracion390Data?.casilla27,
    casilla28: declaracion390Data?.casilla28,
    casilla545: declaracion390Data?.casilla545,
    casilla546: declaracion390Data?.casilla546,
    casilla547: declaracion390Data?.casilla547,
    casilla548: declaracion390Data?.casilla548,
    casilla551: declaracion390Data?.casilla551,
    casilla552: declaracion390Data?.casilla552,
    casilla587: declaracion390Data?.casilla587,
    casilla588: declaracion390Data?.casilla588,
    casilla603: declaracion390Data?.casilla603,
    casilla604: declaracion390Data?.casilla604,
    casilla605: declaracion390Data?.casilla605,
    casilla606: declaracion390Data?.casilla606,
    casilla627: declaracion390Data?.casilla627,
    casilla628: declaracion390Data?.casilla628,
    casilla629: declaracion390Data?.casilla629,
    casilla630: declaracion390Data?.casilla630,
    casilla631: declaracion390Data?.casilla631,
    casilla632: declaracion390Data?.casilla632,
    casilla633: declaracion390Data?.casilla633,
    casilla634: declaracion390Data?.casilla634,
    casilla635: declaracion390Data?.casilla635,
    casilla636: declaracion390Data?.casilla636,
    casilla637: declaracion390Data?.casilla637,
    casilla638: declaracion390Data?.casilla638,
    casilla95: declaracion390Data?.casilla95,
    casilla99: declaracion390Data?.casilla99,
    ejercicioDevengo: declaracion390Data?.ejercicioDevengo,
    ejercicio: state?.year,
    nif,
    apellidosRazonSocial: razonSocial,
  }

  const {
    setValue,
    watch,
    reset,
    formState: { errors },
    trigger,
  } = useForm<$TSMigrationFixMe>({
    values: defaultValues,
    resolver: yupResolver(schemaModelo390),
    mode: "onChange",
    reValidateMode: "onChange",
  })

  const handleValidateFormModelo390 = async () => {
    const isValid = await trigger([
      "actividadPrincipalDescripcion",
      "actividadPrincipalCodigo",
      "actividadPrincipalEpigrafe",
    ])
    if (!isValid) {
      notification.warning({
        body: t("notification.warningModelDeclaration"),
      })
      setSelectedTab(SECCIONES_TYPES.DATOS_ESTADISTICOS)
      return
    }
    setShowModalPresentar(!showModalPresentar)
  }

  const handleUpdateClick = async () => {
    setIsUpdating(true)
    try {
      const { data: updatedData } = await declaracion390DataRefetch()
      if (updatedData) {
        reset(defaultValues)
        notification.success({
          body: `${t("taxSummary.declaracion.successNotification")}`,
        })
        setIsUpdating(false)
      }
    } catch (error) {
      setIsUpdating(false)
      notification.errorServidor()
    }
  }

  return (
    <div className='tw-w-full tw-h-full tw-overflow-hidden tw-bg-white tw-text-left'>
      <div className='tw-h-fit tw-p-3 tw-w-full tw-bg-white tw-shadow'>
        <div className='tw-h-11 tw-flex tw-flex-row tw-w-full tw-items-center tw-justify-between'>
          <div className='tw-flex tw-flex-row tw-gap-4 tw-items-center tw-h-full'>
            <ButtonERP
              customize={{ size: "md", type: "transparent" }}
              onClick={() => history.goBack()}
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
            />
            <span className='tw-rounded tw-h-fit tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#799F2E]'>
              {MODELO_IMPUESTO.MODELO_390}
            </span>
            <span className='tw-text-base tw-font-medium tw-h-fit'>
              {t("modelo390.modal.title")} -{" "}
              {state?.year ?? new Date().getFullYear()}
            </span>
          </div>
          <div className='tw-flex tw-flex-row tw-gap-3'>
            <ButtonERP
              customize={{ size: "md", type: "transparent" }}
              label={`${t("taxSummary.declaracion.updateButton")}`}
              loading={isUpdating}
              disabled={isUpdating}
              icon={<FontAwesomeIcon icon={faArrowsRotateReverse} />}
              onClick={() => handleUpdateClick()}
            />
            <ButtonERP
              customize={{ size: "md", type: "primary" }}
              onClick={handleValidateFormModelo390}
              icon={<FontAwesomeIcon icon={faFileExport} />}
              label={`${t("taxSummary.declaracion.presentar")}`}
            />
          </div>
        </div>
      </div>

      <div className='tw-w-full tw-h-[calc(100%-68px)] tw-flex tw-flex-row'>
        <div className='tw-w-2/5 tw-p-6 tw-flex tw-flex-col tw-items-start tw-border-r tw-border-neutral-25'>
          <p className='tw-font-medium tw-text-base'>
            {t("taxSummary.declaracion.secciones")}
          </p>
          <div className='tw-flex tw-flex-col tw-items-start tw-mt-4 tw-w-full tw-gap-1 tw-text-left'>
            {SECCIONES(t).map(({ id, label }) => (
              <p
                key={id}
                className={`tw-h-10 tw-w-full tw-px-4 hover:tw-bg-neutral-25 ${
                  tabSelected === id ? "tw-bg-neutral-25" : ""
                } tw-flex tw-items-center tw-cursor-pointer tw-rounded tw-truncate`}
                onClick={() => setSelectedTab(id)}
              >
                {label}
              </p>
            ))}
          </div>
        </div>

        <div className='tw-w-4/5 tw-flex tw-flex-col tw-items-start tw-overflow-y-auto'>
          <div className='tw-w-full tw-text-base tw-font-medium tw-flex tw-items-center tw-justify-start tw-px-6 tw-py-4'>
            {SECCIONES(t).find((s) => s.id === tabSelected)?.label}
          </div>
          {declaracion390DataIsLoading ? (
            <Spinner />
          ) : (
            <>
              {tabSelected === SECCIONES_TYPES.SUJETO_PASIVO && (
                <IdentificacionModelo390
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.DEVENGO && (
                <DevengoModelo390
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.DATOS_ESTADISTICOS && (
                <DatosEstadisticos
                  setValue={setValue}
                  watch={watch}
                  errors={errors}
                />
              )}
              {tabSelected === SECCIONES_TYPES.DATOS_REPRESENTANTE && (
                <DatosRepresentante
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.OPERACIONES_REGIMEN_GENERAL && (
                <OperacionesRegimenGeneral
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.RESULTADO_LIQUIDACION_ANUAL && (
                <ResultadoLiquidacionAnual
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.TRIBUTACION_POR_TERRITORIO && (
                <TributacionPorTerritorio
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.RESULTADO_LIQUIDACIONES && (
                <ResultadoLiquidaciones
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.VOLUMEN_OPERACIONES && (
                <VolumenDeOperaciones
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.OPERACIONES_ESPECIFICAS && (
                <OperacionesEspecificas
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {tabSelected === SECCIONES_TYPES.PRORRATA && (
                <Prorrata
                  setValue={setValue}
                  watch={watch}
                  prorrataActivityCount={prorrataActivityCount}
                  setProrrataActivityCount={setProrrataActivityCount}
                />
              )}
              {tabSelected ===
                SECCIONES_TYPES.REGIMENES_DEDUCCION_DIFERENCIADOS && (
                <ActividadesRegimenesDeduccionDiferenciados
                  setValue={setValue}
                  watch={watch}
                />
              )}
            </>
          )}
        </div>
      </div>

      <ModalPresentarModelo390
        show={showModalPresentar}
        setShow={setShowModalPresentar}
        watch={watch}
      />
    </div>
  )
}
export default DeclaracionModelo390
